import React from 'react';
import classnames from 'classnames';
import FilterStickyHeader from '../../FilterStickyHeader';

interface IStickyLayerProps extends IBaseProps {
  isFilterFixed: boolean;
  isExpanded: boolean;
  topOffset: number;
  headerTitle: string;
  showSavedFilterIndicator: boolean;
  beforeSummaryContent?: React.ReactNode;
  summaryItems: { key: string; content: React.ReactNode }[];
  stickyPanel: React.ReactNode;
  onHeaderClick: () => void;
  onMaskClick: () => void;
}

const StickyLayer: React.FC<IStickyLayerProps> = (props) => {
  const {
    style,
    className,
    isFilterFixed,
    isExpanded,
    topOffset,
    headerTitle,
    showSavedFilterIndicator,
    beforeSummaryContent,
    summaryItems,
    stickyPanel,
    onHeaderClick,
    onMaskClick,
  } = props;

  return (
    <div
      style={{ ...style, ...(isFilterFixed ? { top: topOffset } : {}) }}
      className={classnames('dbi-common-filter-v3__sticky-wrapper', className, {
        'dbi-common-filter-v3__sticky-wrapper--fixed': isFilterFixed,
        'dbi-common-filter-v3__sticky-wrapper--expanded': isFilterFixed && isExpanded,
      })}
    >
      <FilterStickyHeader
        title={headerTitle}
        showSavedFilterIndicator={showSavedFilterIndicator}
        beforeSummaryContent={beforeSummaryContent}
        summaryItems={summaryItems}
        onClick={onHeaderClick}
      />
      <div
        className={classnames('dbi-common-filter-v3__sticky-panel', {
          'dbi-common-filter-v3__sticky-panel--fixed': isFilterFixed,
        })}
      >
        {stickyPanel}
      </div>
      <div className="dbi-common-filter-v3__sticky-mask" onClick={onMaskClick} />
    </div>
  );
};

export default StickyLayer;
